import Model from '@/models/Model'

export default class SlGroundSellerSaleCommission extends Model {
  resource() {
    return 'sl_ground_seller_sale_commission'
  }
}